'use client';
import React from 'react';

import { CommentsSectionContext } from './CommentsSectionContext';
import request from '@/utils/queryData/rest/clientRequest';

const CommentsSectionContextProvider = ({
  children,
  postId,
  serverFetchedComments,
}) => {
  const [comments, setComments] = React.useState(serverFetchedComments);
  const [parentCommentId, setParentCommentId] = React.useState(null);

  const reloadComments = React.useCallback(() => {
    new request('comments')
      .get({
        parent: postId,
      })
      .then(data => {
        const unpackedData = data?.data;
        setComments(unpackedData);
      })
      .catch(error => {
        console.error(
          'CommentsSectionContextProvider: Error loading comments',
          error
        );
      });
  }, [postId]);

  React.useEffect(() => {
    if (Array.isArray(serverFetchedComments)) {
      setComments(serverFetchedComments);
    }
  }, [JSON.stringify(serverFetchedComments)]);

  return (
    <CommentsSectionContext.Provider
      value={{
        postId,
        comments,
        reloadComments,
        setParentCommentId,
        parentCommentId,
      }}
    >
      {children}
    </CommentsSectionContext.Provider>
  );
};

export { CommentsSectionContext, CommentsSectionContextProvider };
